/**
 * @generated SignedSource<<ea0f8cf762aa4421e9170b8735839cc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OpsEngagementsPageQuery$variables = {
  includeClosed: boolean;
};
export type OpsEngagementsPageQuery$data = {
  readonly engagements: ReadonlyArray<{
    readonly assets: ReadonlyArray<{
      readonly assetTag: any;
      readonly id: string;
      readonly name: string;
    }>;
    readonly budget: string | null | undefined;
    readonly createdAt: any;
    readonly customer: {
      readonly company: string | null | undefined;
      readonly email: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null | undefined;
    } | null | undefined;
    readonly details: string;
    readonly id: string;
    readonly interests: ReadonlyArray<string>;
    readonly modelFiles: ReadonlyArray<{
      readonly byteSize: number;
      readonly filename: string;
      readonly id: string;
      readonly url: string;
    }>;
    readonly projectName: string | null | undefined;
    readonly scanDetails: any;
    readonly startsOn: any | null | undefined;
    readonly status: string;
    readonly talent: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly slug: string;
    }>;
    readonly wantsConsultation: boolean;
  }>;
};
export type OpsEngagementsPageQuery = {
  response: OpsEngagementsPageQuery$data;
  variables: OpsEngagementsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeClosed"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "includeClosed",
        "variableName": "includeClosed"
      }
    ],
    "concreteType": "Engagement",
    "kind": "LinkedField",
    "name": "engagements",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "interests",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "details",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startsOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "company",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "assets",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "modelFiles",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "byteSize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TalentProfile",
        "kind": "LinkedField",
        "name": "talent",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scanDetails",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wantsConsultation",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsEngagementsPageQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsEngagementsPageQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "53079d2bf4a89ed72139cf3c0a75d5a2",
    "id": null,
    "metadata": {},
    "name": "OpsEngagementsPageQuery",
    "operationKind": "query",
    "text": "query OpsEngagementsPageQuery(\n  $includeClosed: Boolean!\n) {\n  engagements(includeClosed: $includeClosed) {\n    id\n    interests\n    projectName\n    details\n    startsOn\n    budget\n    status\n    createdAt\n    customer {\n      id\n      name\n      email\n      phone\n      company\n    }\n    assets {\n      id\n      assetTag\n      name\n    }\n    modelFiles {\n      id\n      filename\n      byteSize\n      url\n    }\n    talent {\n      id\n      name\n      slug\n    }\n    scanDetails\n    wantsConsultation\n  }\n}\n"
  }
};
})();

(node as any).hash = "c89692e4b6e53617870368434e3ce4c2";

export default node;
